import { Injectable, inject } from '@angular/core';

import { take } from 'rxjs';

import { LogLevel, LogLevels } from './log-level';
import { LoggerConfig } from './logger-config';
import { MapperService } from './mapper.service';
import { METADATA_TOKEN } from './metadata/metadata';
import { SERVER_LOGGER_TOKEN } from './server/server-logger.interface';
import { WriterService } from './writer.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly config = inject(LoggerConfig);
  private readonly mapperService = inject(MapperService);
  private readonly metadataService = inject(METADATA_TOKEN);
  private readonly serverService = inject(SERVER_LOGGER_TOKEN);
  private readonly writerService = inject(WriterService);

  public debug(message: any, ...additional: any[]): void {
    this._log('DEBUG', message, additional);
  }

  public error(message: any, ...additional: any[]): void {
    this._log('ERROR', message, additional);
  }

  public info(message: any, ...additional: any[]): void {
    this._log('INFO', message, additional);
  }

  public log(message: any, ...additional: any[]): void {
    this._log('LOG', message, additional);
  }

  public warn(message: any, ...additional: any[]): void {
    this._log('WARN', message, additional);
  }

  private _log(level: LogLevel, message: any, additional: any[] = []): void {
    if (LogLevels[level] < LogLevels[this.config.level]) return;

    // Find the error if it's the message or in the additional array.
    let error;
    if (message instanceof Error) {
      error = message;
    } else {
      error = additional.find((add) => add instanceof Error);
    }

    const metadata = this.metadataService.getMetadata(LogLevels[level], this.config, message, additional);
    this.mapperService
      .getLogPosition(error)
      .pipe(take(1))
      .subscribe((logPosition) => {
        if (logPosition) {
          metadata.fileName = logPosition.fileName;
          metadata.lineNumber = logPosition.lineNumber;
          metadata.columnNumber = logPosition.columnNumber;
        }

        if (this.config.logToConsole) {
          this.writerService.writeMessage(metadata);
        }

        if (this.serverService.shouldCallServer(this.config, metadata)) {
          this.serverService.logToServer(metadata);
        }
      });
  }
}
